var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgKiaHighlighted(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 53.039,
    height: 59.748,
    viewBox: "0 0 53.039 59.748",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_29457",
    "data-name": "Group 29457",
    transform: "translate(-154 -742.165)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "svgexport-7_20_",
    "data-name": "svgexport-7 (20)",
    transform: "translate(154 742.165)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48766",
    "data-name": "Path 48766",
    d: "M76.459,46.592a.961.961,0,1,1,.9-1.7,11.014,11.014,0,0,1,3.2,2.393,4.54,4.54,0,0,1,1.231,2.987c0,2.811-3.113,5.254-8.148,6.93a60.509,60.509,0,0,1-18.371,2.546A60.5,60.5,0,0,1,36.9,57.2c-5.035-1.676-8.148-4.119-8.148-6.93a4.544,4.544,0,0,1,1.231-2.987,11.015,11.015,0,0,1,3.2-2.393.961.961,0,1,1,.9,1.7,9.161,9.161,0,0,0-2.643,1.949,2.689,2.689,0,0,0-.757,1.73c0,1.89,2.609,3.7,6.824,5.108a58.6,58.6,0,0,0,17.769,2.44,58.606,58.606,0,0,0,17.77-2.44c4.216-1.4,6.823-3.217,6.823-5.107a2.687,2.687,0,0,0-.757-1.73,9.144,9.144,0,0,0-2.643-1.949ZM48.677,43.021a24.169,24.169,0,0,0-6.952,1.915c-1.483.729-2.35,1.52-2.35,2.284,0,1.09,1.634,2.179,4.274,3.058a38.326,38.326,0,0,0,11.618,1.592,38.324,38.324,0,0,0,11.618-1.592c2.641-.88,4.275-1.969,4.275-3.058,0-.764-.866-1.555-2.351-2.284a24.166,24.166,0,0,0-6.951-1.915,35.368,35.368,0,0,1-6.087,4.956.959.959,0,0,1-1.028-.012,35.482,35.482,0,0,1-6.067-4.944ZM55.267,8.5a10.049,10.049,0,1,1-7.107,2.943A10.049,10.049,0,0,1,55.267,8.5Zm5.744,4.306a8.122,8.122,0,1,0,2.379,5.743,8.122,8.122,0,0,0-2.379-5.743ZM49.977,41.6a34.97,34.97,0,0,0,5.29,4.425,35.047,35.047,0,0,0,5.29-4.423A46.03,46.03,0,0,0,71.012,25.761c2.178-5.913,2.527-12.143-.78-17.476a18.044,18.044,0,0,0-2.6-3.245,17.69,17.69,0,0,0-24.732,0,18.044,18.044,0,0,0-2.6,3.245c-3.307,5.333-2.958,11.563-.779,17.476A46.009,46.009,0,0,0,49.977,41.6Z",
    transform: "translate(-28.748 0)",
    fill: "#1a74e2",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_284",
    "data-name": "Ellipse 284",
    cx: 15.884,
    cy: 15.884,
    r: 15.884,
    transform: "translate(10.685 1.444)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "icons8-kia",
    transform: "translate(168 752.793)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50597",
    "data-name": "Path 50597",
    d: "M12.728,12C5.7,12,0,14.85,0,18.364s5.7,6.364,12.728,6.364,12.728-2.85,12.728-6.364S19.758,12,12.728,12Zm0,11.927c-6.2,0-11.238-2.5-11.238-5.563S6.532,12.8,12.728,12.8,23.965,15.3,23.965,18.364,18.925,23.927,12.728,23.927Z",
    transform: "translate(0 -12)",
    fill: "#d50000",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50598",
    "data-name": "Path 50598",
    d: "M15.246,18.383h.21a.113.113,0,0,1,.113.125V24.23a.135.135,0,0,0,.14.134h1.564a.136.136,0,0,0,.141-.134V18.135A.138.138,0,0,0,17.273,18H15.246c-.02,0-.02.019-.02.033v.318C15.226,18.365,15.226,18.383,15.246,18.383Zm3.488,5.981h1.513a.211.211,0,0,0,.181-.132l1.291-3.95s.015-.055.063-.055.062.055.062.055l1.3,3.95a.208.208,0,0,0,.182.132h1.513a.12.12,0,0,0,.1-.047.137.137,0,0,0,.023-.117l-2.106-6.111A.176.176,0,0,0,22.678,18H20.233a.036.036,0,0,0-.034.033v.318a.036.036,0,0,0,.034.033h.208a.114.114,0,0,1,.129.11.2.2,0,0,1-.015.072L18.612,24.2a.132.132,0,0,0,.023.117A.124.124,0,0,0,18.734,24.364ZM8.2,18.383a.126.126,0,0,1,.13.125V24.23a.134.134,0,0,0,.137.135H9.989a.132.132,0,0,0,.133-.134V21.824a.073.073,0,0,1,.073-.083.112.112,0,0,1,.095.061l.006.008,1.789,2.407a.329.329,0,0,0,.24.147h1.782a.134.134,0,0,0,.11-.069.127.127,0,0,0-.016-.139l-2.257-3.1c-.007-.01-.01-.015-.014-.022a.094.094,0,0,1-.011-.028.076.076,0,0,1,0-.021.194.194,0,0,1,.027-.08l0,0,1.872-2.71A.129.129,0,0,0,13.707,18H12.015a.336.336,0,0,0-.242.146L10.3,20.164c-.046.066-.091.069-.1.069h0a.068.068,0,0,1-.073-.067V18.134A.136.136,0,0,0,9.984,18H8.034A.035.035,0,0,0,8,18.033v.318a.035.035,0,0,0,.034.033H8.2Z",
    transform: "translate(-3.757 -14.818)",
    fill: "#d50000",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKiaHighlighted);
export default __webpack_public_path__ + "static/media/KIAHighlighted.aa694ba35737bac41a44437756740aac.svg";
export { ForwardRef as ReactComponent };